export default class NotificationsModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
